import { Component, HostListener, Inject, OnInit, DOCUMENT } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, timer } from 'rxjs';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { BulkUploadResumeModelComponent } from '../bulk-resume-upload-model/bulk-upload-resume-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { AtsResumePollingService } from 'src/app/_services/ats-resume-polling.service';
import { switchMap, takeWhile, tap } from 'rxjs/operators';
import { UnifiedService } from 'src/app/unified/unified.service';
import { IUnifiedIntegration } from 'src/app/unified/unified.types';

import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
    selector: 'app-candidate-listing',
    templateUrl: './candidate-listing.component.html',
    styleUrls: ['./candidate-listing.component.scss'],
    standalone: false
})
export class CandidateListingComponent implements OnInit {

  successMessage: String = '';
  errorMessage: String = '';
  infoMessage: string = '';

  candidateList: any[] = [];
  totalCandidateCount: number = 0;
  candidateListLoader: boolean = false;
  screenedCandidateCount: number = 0;
  showScreenedCandidateCount: boolean = false;

  jobid: string = '';
  jobDetails: any = {};
  isTeamAdmin: boolean = false;

  /** Pagination handler */
  start: number = 0;
  limit: number = 10;
  currentPage: number = 1;
  profilesPerPage: number = 25;

  radioBtnFilter: string = 'score_desc';
  selectedScore: string = 'desc';
  selectedCreatedOn: string = '';

  overallMatchFilters: string[] = [];
  private matchTypes = ['EXCELLENT', 'GOOD', 'POTENTIAL', 'NOT_A_MATCH'];

  subscriptions: Array<Subscription> = [];

  reviewedProfiles: any[] = [];
  tabType: string = 'screenTab';
  currentCandidate: any;
  currentIndex: number;
  showCandidate: boolean = false;
  viewMoreSkills: boolean = false;
  progress = 10;
  private intervalId!: any;
  showProgressBar: boolean = false;
  showProgressBarLoader: boolean = false;
  startScreeningLoader: boolean = false;
  isStopStatusAPICall: boolean = false;
  planRefreshInterval: any = null;
  planRefreshIntervalTemp: any = null;

  /** Available integration variable */
  availableIntegrations: (IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, processing: boolean })[] = [];


  isScrolled: boolean = false;
  private readonly scrollThreshold = 55;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.isScrolled = verticalOffset >= this.scrollThreshold;
  };

  constructor(
    private atsResumeScreenService: AtsResumeScreenService,
    private filterDataHandlerService: FilterDataHandlerService,
    private aggregationService: AggregationService,
    private modelService: NgbModal,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private personSearchService: PersonSearchService,
    private atsResumePollingService: AtsResumePollingService,
    private unifiedService: UnifiedService,
    private localStorageService: LocalStorageService,
    @Inject(DOCUMENT) private document: Document
  ) {

    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.getCandidateList();
    });
    this.subscriptions.push(filterMethodEvent);

    const getCandidateSubscription = this.atsResumeScreenService.getCandidateReRunEvent.subscribe((res: any) => { this.getCandidateList() });
    this.subscriptions.push(getCandidateSubscription);

  }

  ngOnInit() {
    const preferenceArray = this.localStorageService.getItem('userdata').preferenceData;
    // check if the user is a team admin
    this.isTeamAdmin = !!this.localStorageService.getItem('isteamAdmin');
    preferenceArray && preferenceArray.length && preferenceArray.map(item => {
      if (item.listing_type == 'screenai-candidate-listing' && item.preference_type == 'page-size') {
        this.profilesPerPage = item.preference_value;
      }
    })

    this.jobid = window.location.pathname?.split('/')[3];
    if (this.activeRouter.snapshot.queryParams['upload']) {
      this.uploadCandidate();
    };

    this.getATSConnectedDetails();

    this.getJobDetails();
    this.getCandidateList();

    this.showProgressBarLoader = true;
    // this.showProgressBar = true;
    // this.showScreenedCandidateCount = true;
    this.planRefreshIntervalTemp = setTimeout(() => {
      this.getStatusOfResumeScreening();
    }, 500);
    // this.getStatusOfResumeScreening();
    // this.showProgressBar = true;
    this.startInterval();

  }


  /**
   * Get connected ats details
   */
  getATSConnectedDetails() {
    this.unifiedService.getUserUnifiedIntegrations('', true).subscribe((integrations: any) => {
      if (integrations.status == 'success') {
        this.availableIntegrations = integrations.data;
      }
    });
  };

  get screeningTooltip(): string {
    if (!this.isTeamAdmin) {
        return 'You don\'t have permission to import jobs from ATS';
    }
    if (!this.availableIntegrations?.length) {
        return 'Please connect your ATS';
    }
    return '';
  }

  /**
   * Handle radio button filter for candidate listing
   * @param event
   */
  onFilterChange(event: any) {
    const selectedFilterInput = event.target.value;
    switch (selectedFilterInput) {

      case 'score_desc':
        this.radioBtnFilter = selectedFilterInput;
        this.selectedScore = 'desc';
        this.selectedCreatedOn = '';
        break;

      case 'score_asc':
        this.radioBtnFilter = selectedFilterInput;
        this.selectedScore = 'asc';
        this.selectedCreatedOn = '';
        break;

      case 'createdon_desc':
        this.radioBtnFilter = selectedFilterInput;
        this.selectedScore = '';
        this.selectedCreatedOn = 'desc';
        break;

      case 'createdon_asc':
        this.radioBtnFilter = selectedFilterInput;
        this.selectedScore = '';
        this.selectedCreatedOn = 'asc';
        break;
    };

    this.getCandidateList();

  };

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    clearInterval(this.planRefreshInterval);
  }


  getCandidateList() {

    this.candidateListLoader = true;
    const requestObject = this.aggregationService.getRequestWithFilters();

    const payload = {
      jobid: this.jobid,
      category: requestObject.matchcategory,
      search: requestObject.booleanquery !== '*' ? requestObject.booleanquery : '',
      start: this.start,
      limit: this.profilesPerPage,
      score: this.selectedScore,
      createdon: this.selectedCreatedOn
    }

    this.atsResumeScreenService.getCandidateList(payload).subscribe((res: any) => {
      if (res && (res.success || res?.status == 'success')) {
        this.candidateList = res?.data?.results;
        this.totalCandidateCount = res?.data?.candidatesCount;
      } else {
        this.candidateList = [];
        this.totalCandidateCount = 0;
        // this.screenedCandidateCount = 0;
      }
      this.candidateListLoader = false;
      if (this.showScreenedCandidateCount && this.screenedCandidateCount < this.totalCandidateCount) {
        this.successMessage = `${Number(this.totalCandidateCount) - Number(this.screenedCandidateCount)} Candidates Screened!`;
        setTimeout(() => { this.successMessage = ''; }, 5000);
        this.showScreenedCandidateCount = false;
      }
      this.screenedCandidateCount = res?.data?.candidatesCount;
    }, (err) => {
      this.candidateList = [];
      this.totalCandidateCount = 0;
      this.screenedCandidateCount = 0;
      this.candidateListLoader = false;
    })


  }


  getJobDetails() {

    this.atsResumeScreenService.getSingleJobDetails(this.jobid).subscribe((res: any) => {
      if (res && res.body && res.body.status == 'success') {
        this.jobDetails = res.body;
      } else {
        this.jobDetails = {};
      }
    })
  };

  /**
   * Handle redirection for job details page
   */
  openViewJobDetails() {
    this.router.navigate([`/resume-screen/job-details/${this.jobid}`]);
  };


  uploadCandidate() {
    const modalRef = this.modelService.open(BulkUploadResumeModelComponent, { size: 'md' as 'md', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.id = this.jobid;
    modalRef.componentInstance.event.subscribe((res: any) => {
      if (res.status == 'success') {
        this.getStatusOfResumeScreening();
        this.showProgressBar = true;
        this.startInterval();
        this.modelService.dismissAll();
      } else if(res.status == 'cancel') {
        this.modelService.dismissAll();
      } else {
        this.errorMessage = 'Something went wrong, Please try agian!';
        setTimeout(() => { this.errorMessage = ''; }, 3000);
      }
    });
  };


  /**
  * Method to fetch all the imported jobs
  */
  startScreening(job: any) {
    const payload = {
      jobId: job.unified_job_id,
      type: "on-demand",
      source: job.source ? job.source : 'create'
    }
    this.showScreenedCandidateCount = true;
    this.startScreeningLoader = true;
    this.atsResumeScreenService.startScreening(payload).subscribe((response: any) => {
      if (response && (response.success || response?.status == 'success' )) {
        this.showProgressBar = true;
        this.planRefreshIntervalTemp = setTimeout(() => {
          this.getStatusOfResumeScreening();
        }, 500);
        this.startInterval();
      } else {
        this.errorMessage = 'Something went wrong!';
        setTimeout(() => { this.errorMessage = ''; }, 3000);
      }
      this.startScreeningLoader = false;
    })
  };

  /**
    * Handles child events and accordingly calls specified function
    * @param event childevent
    */
  eventHandler(event: any) {
    setTimeout(() => {
      const index = event?.data?.currentIndex;
      if (index !== undefined && index >= 0 && this.reviewedProfiles && this.reviewedProfiles[index]) {
        event.data.lastseencount = 1;
        this.reviewedProfiles[index].lastseencount = 1;
      }
    }, 1000);

    let val = event.data.idinindex
    this.reviewedProfiles.find(function (item, i) {
      if (item.idinindex === val) {
        index = i;
        return i;
      }
    });

    /**Handle if slider called from screen AI then add jobsource key inside candidate data */
    if (this.jobDetails?.data?.source == 'import') {
      event.data.jobsource = 'import'
    } else {
      event.data.jobsource = 'create'
    };

    let index = -1;

    if (event.action == 'append-data' && event.data != undefined && typeof event.data == 'object') {

      let val = event.data.idinindex
      this.reviewedProfiles.find(function (item, i) {
        if (item.idinindex === val) {
          index = i;
          return i;
        }
      });

      if (event.data && event.data.existingContactDetails) {
        this.reviewedProfiles[index]['existingContactDetails'] = event.data.existingContactDetails;
        this.reviewedProfiles[index]['candidatenumber'] = event.data.candidatenumber;
        this.reviewedProfiles[index] = Object.assign([], this.reviewedProfiles[index]);

      }
      if (event.data && event.data.iswebbtreeverified) {
        this.reviewedProfiles[index]['iswebbtreeverified'] = 1;
      }

      if (event.data && event.data.usedWebbtreeIntroduction) {
        this.reviewedProfiles[index]['usedWebbtreeIntroduction'] = 1;
      }
      if (event.data && event.data.revealContactAttempted) {
        this.reviewedProfiles[index]['revealContactAttempted'] = 1;
      }

    }

    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');

    if (event.action == 'openNav') {
      if (event.type == 'show-contact') {
        this.tabType = 'contactTab'
      } else if (event.type == 'show-activity') {
        this.tabType = 'activityTab'
      } else if (event.type == 'show-skills') {
        this.tabType = 'profileTab'
        this.viewMoreSkills = true;
      }
      else {
        this.tabType = 'screenTab'
      }

      if (event.data && event.data.experience && event.data.experience.length && event.data.experience[0].company) {
        const companyObjects = _.pluck(event.data.experience, 'company');
        const payload = companyObjects.map(item => {
          if (item?.id || item?.name) {
            return {
              ...(item?.id && { id: item?.id }),
              ...(item?.name && { name: item?.name })
            }
          }
        }).filter(Boolean);

        if (!payload?.length)
          this.openCandidateSlider(index == -1 ? event.data : this.reviewedProfiles[index], event.currentIndex);
        payload?.length && this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
          if (res && res.status == "success") {
            const resultName = res.data
            resultName.forEach(obj => {
              const matchingObj = event.data.experience.filter((item) => ((obj.searchedVia === 'id' && obj.key === item.id) || (obj.searchedVia === 'name' && obj.key === item.name)));
              if (matchingObj && matchingObj.length) {
                let companyLogo = obj.companylogo
                matchingObj.forEach(x => {
                  x.companylogo = companyLogo;
                })

              }
            });

            this.openCandidateSlider(index == -1 ? event.data : this.reviewedProfiles[index], event.currentIndex)
          } else {
            this.openCandidateSlider(index == -1 ? event.data : this.reviewedProfiles[index], event.currentIndex)
          }
        });
      } else {
        this.openCandidateSlider(index == -1 ? event.data : this.reviewedProfiles[index], event.currentIndex)
      }
    } else if (event.action == 'closeNav') {
      this.closeNav();
    }

  };

  openCandidateSlider(data: any, currentIndex: number) {
    this.currentCandidate = data;
    this.currentIndex = data.currentIndex
    this.showCandidate = true;
    document.getElementById("quickView").style.width = "55%";
    document.getElementById("quickView").style.right = "0";
    document.getElementById("overlay").style.display = "block";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
  }

  closeNav() {
    this.viewMoreSkills = false;
    this.showCandidate = false
    document.getElementById("quickView").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("quickView").style.right = "-50px";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
  };

  /**
   * Handle status API polling state
   */
  getStatusOfResumeScreening() {
    if (this.showProgressBar) {
      this.showProgressBarLoader = false;
    } else {
      this.showProgressBarLoader = true;
    }
    this.atsResumeScreenService.syncCandidate(this.jobid).subscribe((res: any) => {
      this.showProgressBar = true;
      if (res?.body && res?.body?.data && (res?.body?.data?.status == 'pending' || res?.body?.data?.status == 'validating' || res?.body?.data?.status == 'completed')) {
        this.progress = res.body.data?.progress == null ? 0 : res.body.data?.progress;
        if (this.progress >= 100) {
          this.showProgressBar = false;
          this.progress = 10;
          clearInterval(this.planRefreshInterval);
          setTimeout(() => {
            this.getJobDetails();
            this.getCandidateList();
          }, 500);
        }
      } else if (res?.body && res?.body?.data?.status == 'failure' && res.body.data?.progress == 100) {
        clearInterval(this.planRefreshInterval);
        this.showProgressBar = false;
        this.progress = 10;
        setTimeout(() => {
          this.getJobDetails();
          this.getCandidateList();
        }, 500);
      } else if (res?.body && res?.body?.data?.status == 'no-data') {
        clearInterval(this.planRefreshInterval);
        this.showProgressBar = false;
        this.progress = 10;
        this.successMessage = 'Sync completed. No new candidates were found for this job.';
        setTimeout(() => { this.successMessage = ''; }, 3000);
      } else if (res?.body && res?.body?.data?.status == 'no-batch-found') {
        clearInterval(this.planRefreshInterval);
        this.showProgressBar = false;
        this.progress = 10;
      } else {
        clearInterval(this.planRefreshInterval);
        this.showProgressBar = false;
        this.progress = 10;
      }
      this.showProgressBarLoader = false;
    })
  }

  /**
   * Start polling when is required
   */
  startInterval() {
    // this.showProgressBar = true;
    this.showProgressBarLoader = true;
    this.planRefreshInterval = setInterval(() => {
      this.getStatusOfResumeScreening();
    }, 20000);
  };

/**
 * Method to handle pagination
 * @param index
 */
  setPage(index: number) {
    this.start = (index - 1) * Number(this.profilesPerPage);
    if (index == 1) this.currentPage = 1;
    this.getCandidateList();
    this.document.documentElement.scrollTop = 0;
  };

  /**
   * Used to change number of profiles on each page
   */
  updatePagePreference() {
    const data = {
      preference_type: 'page-size',
      preference_value: this.profilesPerPage,
      listing_type: 'screenai-candidate-listing'
    };

    try {
      this.personSearchService.updatePagePreference(data);
      this.setPage(1);
    } catch {
      this.errorMessage = "Something went wrong";
      setTimeout(() => this.errorMessage = '', 5000);
    }
  };

}
